import { createReducer, on } from '@ngrx/store';

import { BetslipPlaceBetActions } from '../actions';
import { defaultBetslipPlaceButtonState } from '../state';

export const placeButtonReducer = createReducer(
    defaultBetslipPlaceButtonState,
    on(BetslipPlaceBetActions.setMode, (state, action) => {
        return {
            ...state,
            mode: action.mode,
        };
    }),
    on(BetslipPlaceBetActions.validatePlaceButton, (state, action) => {
        return {
            ...state,
            isValid: action.isValid,
        };
    }),
    on(BetslipPlaceBetActions.setAuthentication, (state, action) => {
        return {
            ...state,
            isAuthenticated: action.isAuthenticated,
        };
    }),
);
